import angular from 'angular';
import mergeFieldOption from './mergeFieldOption';
import './style.scss';

export default angular
  .module('components.mergeFieldOption', [])
  .component('mergeFieldOption', mergeFieldOption).name;
